import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "m1.5 17.692.375-1.5h4.99l-.375 1.5zm2-3.884.375-1.5h5.99l-.374 1.5zm15.056 6.201.5-4.018.715-5.905.26-2.07zM4.51 21.5l.182-1.5h13.864L20.03 8.015h-3L16.656 11h-1.5l.36-2.985H11.03L10.656 11H9.14l.36-2.985H6.087L6.269 6.5h3.414l.028-.25c.134-1.18.542-2.1 1.226-2.76.683-.66 1.614-.99 2.794-.99 1.022 0 1.864.383 2.528 1.149.663.766.967 1.665.912 2.697l-.019.154h4.53l-1.855 15zm6.673-15h4.484l.02-.154a2.142 2.142 0 0 0-.572-1.648A2.046 2.046 0 0 0 13.538 4c-.687 0-1.226.198-1.619.595-.393.397-.629.949-.709 1.655z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }